import http from './reddit'
import acount from './acount'
import liveshow from './liveshow'
import operator from './operator'
import generalLedger from './general-ledger'
import assortLedger from './assort-ledger'
import operatorGroup from './operator-group'
import gameLobby from './game-lobby'
import personalCenter from './personal-center'
import setting from './setting'
import periodManagement from './period-management'
import openManagement from './open-management'
import traderecord from './traderecord'
import cq9 from './cq9'
import websiteManagement from './website-management'
export default {
    // 共通
    login: (data) => http.Post(`${http.url.Newcommon}/login`, data),     // 登入api 
    logout: (data) => http.Post(`${http.url.Newcommon}/logout`, data),   // 登出api
    isregin: (data) => http.Post(`${http.url.Newcommon}/isregin`, data),  // 重复登录
    foop: (gameid, data) => http.Post(`${http.url.six}/foop/${gameid}`, data), // 快速开盘
    country: () => http.Get(`${http.url.ip}`),                     // IP位置
    uptpodds: () => http.Get(`${http.url.Newcommon}/uptpodds`), // header 現場監督 文字 
    companyname: () => http.Get(`${http.url.Newcommon}/companyname`), // 公司名稱
    linkonlinemem: ({ siteid, startTiem, endTiem }) => http.Get(`${http.url.Newcommon}/linkonlinemem/${siteid}/${startTiem}/${endTiem}`), // 再线人数
    linkinonlinemem: () => http.Get(`${http.url.Newcommon}/linkinonlinemem/0`), // 再线人数
    linkbetmem: ({ siteid, startTiem, endTiem }) => http.Get(`${http.url.Newcommon}/linkbetmem/${siteid}/${startTiem}/${endTiem}`), // 下注人數
    iprepmem: () => http.Get(`${http.url.Newcommon}/iprepmem`),
    acount,   // 帳號管理
    liveshow, // 現場監督
    generalLedger, // 总帐
    assortLedger, // 分类
    traderecord, //操盤紀錄
    openManagement, // 开奖管理                                 
    periodManagement, // 期数管理
    setting, // 系统设定
    gameLobby,   // 彩种总表
    operator,      // 操作員
    operatorGroup, // 操作員組
    personalCenter, // 个人中心
    cq9, // 电子游戏cq9 api
    websiteManagement // 网站管理
}